import React from 'react';
import TexasAC from '../components/TexasAC'; // adjust path as necessary

const TexasACPresentation = () => {
  return (
    <>
      <TexasAC />
    </>
  );
};

export default TexasACPresentation;
